ko.bindingHandlers.bindElement = {
    init: function (element, valueAccessor) {
        valueAccessor()(element);
    }
};